import { render, staticRenderFns } from "./DipsDialog.vue?vue&type=template&id=7832423c&scoped=true"
import script from "./DipsDialog.vue?vue&type=script&lang=js"
export * from "./DipsDialog.vue?vue&type=script&lang=js"
import style0 from "./DipsDialog.vue?vue&type=style&index=0&id=7832423c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7832423c",
  null
  
)

export default component.exports